import { isEmail } from 'validator';

import { countryDefinitions } from 'common/helpers/addresses';
import { validateForUI } from 'common/helpers/jsonValidator';

const formSchema = (ownProps) => {
  const schema = {
    type: 'object',
    properties: {
      firstName: { type: 'string' },
      lastName: { type: 'string' },
      email: { type: 'string' },
      zipCode: {
        type: 'string',
        pattern: '[A-Z0-9]',
        minLength: 3,
        maxLength: 10
      },
      countryCode: { type: 'string', maxLength: 2, minLength: 2 }
    },
    required: ['email'],
    additionalProperties: false
  };
  if (ownProps.hasNameFields) {
    schema.required.push('firstName');
    schema.required.push('lastName');
  }
  if (ownProps.hasZipCode) {
    schema.required.push('zipCode');
    schema.required.push('countryCode');
  }
  return schema;
};

export const validateSubmit = (form, ownProps) => {
  const errors = validateForUI(
    formSchema(ownProps),
    form,
    customValidate(form)
  );
  return errors;
};

const customValidate = (form) => {
  const errorArray = [];
  if (form.countryCode) {
    const { requiredFormFields } = countryDefinitions[form.countryCode];
    const zipValidator = requiredFormFields.find(
      (field) => field.field === 'zipCode'
    );
    if (zipValidator) {
      if (!zipValidator.validationRegex.test(form.zipCode)) {
        errorArray.push({
          field: 'zipCode',
          message: zipValidator.error
        });
      }
    }
  }
  if (form.email && !isEmail(form.email)) {
    errorArray.push({
      field: 'email',
      message: 'Invalid Email'
    });
  }
  return errorArray;
};
